// extracted by mini-css-extract-plugin
module.exports = {"selected":"styles_selected__lgwjF","grow":"styles_grow__FsfLD","arrow-up":"styles_arrow-up__sre1l"};